/* tslint:disable */
/* eslint-disable */
/**
 * Melco Identity APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    IdentityMelcoModelsCulture,
    IdentityMelcoModelsCultureFromJSON,
    IdentityMelcoModelsCultureFromJSONTyped,
    IdentityMelcoModelsCultureToJSON,
    IdentityMelcoModelsCustomWarning,
    IdentityMelcoModelsCustomWarningFromJSON,
    IdentityMelcoModelsCustomWarningFromJSONTyped,
    IdentityMelcoModelsCustomWarningToJSON,
} from './';

/**
 * 
 * @export
 * @interface IdentityMelcoModelsGenericList1MelcoModelsCulture
 */
export interface IdentityMelcoModelsGenericList1MelcoModelsCulture {
    /**
     * 
     * @type {Array<IdentityMelcoModelsCulture>}
     * @memberof IdentityMelcoModelsGenericList1MelcoModelsCulture
     */
    list: Array<IdentityMelcoModelsCulture>;
    /**
     * 
     * @type {Array<IdentityMelcoModelsCustomWarning>}
     * @memberof IdentityMelcoModelsGenericList1MelcoModelsCulture
     */
    warning_list?: Array<IdentityMelcoModelsCustomWarning> | null;
    /**
     * 
     * @type {number}
     * @memberof IdentityMelcoModelsGenericList1MelcoModelsCulture
     */
    total: number;
}

export function IdentityMelcoModelsGenericList1MelcoModelsCultureFromJSON(json: any): IdentityMelcoModelsGenericList1MelcoModelsCulture {
    return IdentityMelcoModelsGenericList1MelcoModelsCultureFromJSONTyped(json, false);
}

export function IdentityMelcoModelsGenericList1MelcoModelsCultureFromJSONTyped(json: any, ignoreDiscriminator: boolean): IdentityMelcoModelsGenericList1MelcoModelsCulture {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'list': ((json['list'] as Array<any>).map(IdentityMelcoModelsCultureFromJSON)),
        'warning_list': !exists(json, 'warning_list') ? undefined : (json['warning_list'] === null ? null : (json['warning_list'] as Array<any>).map(IdentityMelcoModelsCustomWarningFromJSON)),
        'total': json['total'],
    };
}

export function IdentityMelcoModelsGenericList1MelcoModelsCultureToJSON(value?: IdentityMelcoModelsGenericList1MelcoModelsCulture | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'list': ((value.list as Array<any>).map(IdentityMelcoModelsCultureToJSON)),
        'warning_list': value.warning_list === undefined ? undefined : (value.warning_list === null ? null : (value.warning_list as Array<any>).map(IdentityMelcoModelsCustomWarningToJSON)),
        'total': value.total,
    };
}


